import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { navlink } from "../../../data/navlink";
import { Link } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { FaChevronDown } from "react-icons/fa";

export default function NavigationBarForMobile({ setOpenMenu }) {
  const [openDropdown, setOpenDropdown] = useState(null);

  // Prevent Page Scrolling When Menu is Open
  useEffect(() => {
    document.body.style.overflow = "hidden"; // Disable scrolling
    return () => {
      document.body.style.overflow = "auto"; // Re-enable scrolling when menu closes
    };
  }, []);

  // Toggle Dropdowns
  const handleDropdownToggle = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  return (
    <motion.div
      className="fixed inset-0 h-screen bg-black/80 backdrop-blur-lg text-white z-50 flex flex-col items-center px-6 overflow-hidden"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{ type: "spring", stiffness: 100, damping: 15 }}
    >
      {/* Close Button (Fixed) */}
      <button
        onClick={() => setOpenMenu(false)}
        className="absolute top-4 right-4 text-white hover:text-goldenYellow transition"
      >
        <RxCross1 size={30} />
      </button>

      {/* Navigation Menu (Scrollable Inside, Not Page) */}
      <div className="w-full max-w-md flex flex-col items-start space-y-4 mt-16 overflow-y-auto scrollbar-hidden h-full">
        {navlink.map((data, index) => (
          <div key={index} className="w-full">
            {/* Dropdown Menu */}
            {data.dropdown ? (
              <div className="w-full">
                <button
                  className="flex justify-between items-center w-full py-3 px-4 text-xl font-semibold bg-white/10 backdrop-blur-lg rounded-lg hover:text-goldenYellow transition"
                  onClick={() => handleDropdownToggle(index)}
                >
                  {data.name}
                  <FaChevronDown
                    className={`ml-2 transition-transform duration-300 ${
                      openDropdown === index ? "rotate-180" : "rotate-0"
                    }`}
                  />
                </button>

                {/* Dropdown Content (Scrollable Inside, Not Page) */}
                {openDropdown === index && (
                  <motion.div
                    className="mt-2 space-y-2 text-lg overflow-y-auto max-h-48 bg-white/10 backdrop-blur-lg p-3 rounded-lg scrollbar-hidden"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                  >
                    {data.dropdownMenu.map((item, i) => (
                      <Link
                        key={i}
                        to={
    data.name === "Practices"
      ? `/practice/${item}`
      : item === "Internship"
      ? "/career/internship"
      : "/career/retainership"
  }
                        className="block py-2 px-4 hover:text-goldenYellow transition"
                        onClick={() => setOpenMenu(false)}
                      >
                        {item}
                      </Link>
                    ))}
                  </motion.div>
                )}
              </div>
            ) : (
              // Normal Menu Links
              <Link
                to={data.link}
                className="block w-full py-3 px-4 text-xl font-semibold bg-white/10 backdrop-blur-lg rounded-lg hover:text-goldenYellow transition"
                onClick={() => setOpenMenu(false)}
              >
                {data.name}
              </Link>
            )}
          </div>
        ))}
      </div>
    </motion.div>
  );
}
